import { useEffect, useState } from "react"
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { AdquisitionItemSelector } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem, _AdquisitionItemBudgetID, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { ListMenu } from "../../../../../theme/Component/ListMenu";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}
export const SACDP001 = ({ configProcedure }: Props) => {

    const { bean, setBean, instance } = useDataBean(_AdquisitionItem);
    const _budget = useDataBean(_AdquisitionItemBudgetID);
    const [invalid, setInvalid] = useState<boolean>(false);
    const [props, setProps] = useState<any>({})
    const [editedBudgetList, setEditedBudgetList] = useState<any[]>([]);

    const [modal, setModal] = useState<any>({ name: "Modificar Valores Presupuestales", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        setBean({
            obs: ''
        });
    }, [])

    const getCurrentBudgetList = () => {
        if (!_budget.bean?.IDRow) {
            return editedBudgetList;
        }

        return editedBudgetList.map((budgetItem) => {
            if (budgetItem?.DataBeanProperties?.IDRow !== _budget.bean.IDRow) {
                return budgetItem;
            }

            return {
                ...budgetItem,
                DataBeanProperties: {
                    ...budgetItem.DataBeanProperties,
                    ..._budget.bean,
                }
            };
        });
    };

    const saveSupplier = () => {
        if (!bean.IDAdquisitionItem) {
            toast.error("Debe seleccionar una necesidad");
            return;
        }

        if (!bean.obs || bean.obs.trim().length <= 15) {
            setInvalid(true);
            toast.error("La observacion debe tener un minimo de 15 caracteres");
            return;
        }

        const currentBudgetList = getCurrentBudgetList();

        if (currentBudgetList.length === 0) {
            toast.error("La necesidad no tiene rubros presupuestales para continuar");
            return;
        }

        const invalidBudgetIndex = currentBudgetList.findIndex((budgetItem) => {
            const budget = budgetItem?.DataBeanProperties;
            const estimatedValue = Number(budget?.EstimatedValue);

            return !budget?.JsonCode ||
                !budget?.IDBudgetResource ||
                !budget?.IDBudgetSource ||
                !Number.isFinite(estimatedValue) ||
                estimatedValue <= 0;
        });

        if (invalidBudgetIndex !== -1) {
            toast.error(`El rubro ${invalidBudgetIndex + 1} debe tener recurso, fuente y un valor estimado mayor que cero`);
            return;
        }

        const exceededBudgetIndex = currentBudgetList.findIndex((budgetItem) => {
            const budget = budgetItem?.DataBeanProperties;
            const estimatedValue = Number(budget?.EstimatedValue);
            const leftValue = Number(budget?.LeftValue);

            return !Number.isFinite(leftValue) || estimatedValue > leftValue;
        });

        if (exceededBudgetIndex !== -1) {
            const budget = currentBudgetList[exceededBudgetIndex].DataBeanProperties;
            toast.error(
                `El valor estimado (${budget.EstimatedValue}) del rubro ${budget.JsonCode ?? exceededBudgetIndex + 1} no puede superar el valor restante (${budget.LeftValue ?? 0})`
            );
            return;
        }

        const validBudgetList = currentBudgetList.map((budgetItem) => {
            const budget = budgetItem.DataBeanProperties;

            return {
                DataBeanProperties: {
                    JsonCode: budget.JsonCode,
                    BudgetName: budget.BudgetName ?? budget.BudgetIDName,
                    IDBudgetResource: budget.IDBudgetResource,
                    NameResource: budget.NameResource ?? budget.BudgetResourceName,
                    IDBudgetSource: budget.IDBudgetSource,
                    NameSource: budget.NameSource ?? budget.BudgetSourceName,
                    EstimatedValue: Number(budget.EstimatedValue),
                }
            };
        });

        console.log(validBudgetList)

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(bean.obs)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({ ...bean, HasProject: bean.IDProject ? 1 : 2 })
        }

        if (configProcedure?._pushProps) {
            configProcedure._pushProps({
                ...bean,
                budgetList: JSON.stringify(validBudgetList),
                ...(props?.IDBoss != null
                    ? { AssignTo: props.IDBoss }
                    : {})
            });
        }
    }

    useEffect(() => {
        if (bean.IDAdquisitionItem) {
            getBudget(bean.IDAdquisitionItem);
        }
    }, [bean.IDAdquisitionItem])

    const getBudget = (idItem: number) => {
        _budget.instance.getAdquisitionItemBudgetIDCatalog(idItem).then(
            (resp) => {

                console.log(resp);

                const sortedList = resp.sort((a: any, b: any) =>
                    a.IDAdquisitionItemBudgetID - b.IDAdquisitionItemBudgetID
                );

                sortedList.forEach(element => {
                    element.DataBeanProperties.IDRow = _single.getRandomInt();
                });

                _budget.setLista(sortedList);
                setEditedBudgetList([...sortedList]);

            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo cargar los rubros")
            }
        )
    }

    const head = [
        { title: 'ID', property: "IDAdquisitionItemBudgetID", mask: MASK_NUMBER },
        { title: 'Codigo Rubro', property: 'JsonCode' },
        { title: 'Nombre Rubro', property: 'BudgetName' },
        { title: 'Recurso', property: 'NameResource' },
        { title: 'Valor Estimado', property: 'EstimatedValue', mask: MASK_MONEY },
        { title: 'PI', property: 'PIValue', mask: MASK_MONEY },
        { title: 'Valor Restante', property: 'LeftValue', mask: MASK_MONEY },
        // { title: 'CDP', property: 'CDPValue', mask: MASK_MONEY },
        // { title: 'RCDP', property: 'RCDPValue', mask: MASK_MONEY },
        // { title: 'Saldo CDP', property: 'LeftValue', mask: MASK_MONEY, visible: true },
        // { title: 'Funcionario', property: 'EmployeeName', visible: false },
        // { title: 'Observaciones', property: 'Description', visible: false },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar por Menor Valor', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "name": `Editar por Valor Menor`, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const guardarCambios = () => {
        const estimatedValue = Number(_budget.bean?.EstimatedValue);
        const leftValue = Number(_budget.bean?.LeftValue);

        if (!Number.isFinite(estimatedValue) || estimatedValue <= 0) {
            toast.error("El valor estimado debe ser mayor que cero");
            return;
        }

        if (!Number.isFinite(leftValue) || estimatedValue > leftValue) {
            toast.error(`El valor estimado (${_budget.bean.EstimatedValue}) no puede superar el valor restante (${_budget.bean.LeftValue ?? 0})`);
            return;
        }

        const updatedList = editedBudgetList.map((budgetItem) => {
            // if (budgetItem.DataBeanProperties.IDAdquisitionItemBudgetID === _budget.bean.IDAdquisitionItemBudgetID) {
            if (budgetItem.DataBeanProperties.IDRow === _budget.bean.IDRow) {
                return {
                    ...budgetItem,
                    DataBeanProperties: {
                        ..._budget.bean
                    }
                };
            }
            return budgetItem;
        });

        console.log(updatedList)

        setEditedBudgetList(updatedList);
        setModal({ ...modal, view: false });
    };



    return (
        <div className="row">
            <div className="col-12">
                <AdquisitionItemSelector ConfigProps={{ filterState: 6, disable: props.IDAdquisitionItem ? true : false }} idAdquisitionItem={props.IDAdquisitionItem ? props.IDAdquisitionItem : bean.IDAdquisitionItem} onChage={(item: any) => {
                    setBean({ ...bean, "IDAdquisitionItem": item.IDAdquisitionItem, "TotalArticle": item.TotalArticle, "IDLnFunctionalID": item.IDLnFunctionalID, IDProject: item.IDProject });
                }} />
            </div>

            {bean.IDAdquisitionItem &&
                <BasicTable head={head} body={editedBudgetList} rowSet={_budget.setBean} listButtons={listaBotones()} />

            }
            <div className="col-md-12">
                <label>Observaciones:</label>
                <textarea placeholder="Observación minimo 15 caracteres" className={`form-control ${invalid ? "is-invalid" : ""}`} onBlur={() => { setInvalid(false) }} value={bean.obs} onChange={(e) => { setBean({ ...bean, "obs": e.target.value }) }} />
            </div>

            <div className="col-md-12">

                <div className="row mt-4 ">
                    <div className="col-md-6">
                        <BasicButton children={"Continuar"} eventClick={saveSupplier} icon="ri-save-line" />
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={guardarCambios}>
                    <div className="row">
                        <div className="col-md-12">
                            {_budget.bean && _budget.bean && (
                                <InputMoney
                                    _label="Valor Estimado"
                                    _value={_budget.bean.EstimatedValue}
                                    onChange={(newValue) => {
                                        _budget.setBean({
                                            ..._budget.bean,
                                            EstimatedValue: newValue
                                        });
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </Modal>

            </div>
        </div>
    )
}
